export default __webpack_public_path__ + "b5e49d483c3d57198b9d0ef07ca16924.jpg";